import { render, staticRenderFns } from "./healthcare.vue?vue&type=template&id=51051e22&scoped=true"
import script from "./healthcare.vue?vue&type=script&lang=js"
export * from "./healthcare.vue?vue&type=script&lang=js"
import style0 from "./healthcare.vue?vue&type=style&index=0&id=51051e22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51051e22",
  null
  
)

export default component.exports